/* Farfhe Banner Slider controller — autoplay, crossfade, arrow/dot/keyboard nav,
   touch swipe, pause-on-hover/visibility, syncs video play state with active slide. */
(function () {
  'use strict';

  function initSlider(root) {
    if (root.dataset.fbsInit === '1') return;
    root.dataset.fbsInit = '1';

    var slides = Array.from(root.querySelectorAll('[data-fbs-slide]'));
    if (slides.length <= 1) return;

    var dots = Array.from(root.querySelectorAll('[data-fbs-dot]'));
    var prevBtn = root.querySelector('[data-fbs-prev]');
    var nextBtn = root.querySelector('[data-fbs-next]');
    var playPauseBtn = root.querySelector('[data-fbs-playpause]');
    var viewport = root.querySelector('[data-fbs-viewport]');

    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var current = 0;
    var timer = null;
    var paused = false;
    var locked = false; // true while a slide's block is selected in the theme editor

    root.style.setProperty('--fbs-autoplay-ms', autoplaySpeed + 'ms');

    function syncVideos() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('[data-fbs-video], video');
        if (!video) return;
        if (i === current) {
          try {
            video.currentTime = 0;
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {}
        } else {
          try { video.pause(); } catch (e) {}
        }
      });
    }

    function goTo(index) {
      if (index === current) return;
      var total = slides.length;
      var next = ((index % total) + total) % total;

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = next;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }

      // No forced-reflow reset needed here: the dot-progress fill animation
      // is triggered purely by CSS (.dot.is-active .dot-progress { animation: ... }),
      // and .is-active always moves to a *different* dot element each time.
      // A DOM element newly matching an animating selector always starts its
      // animation fresh — there's nothing to "restart" on the same element,
      // so the previous style.animation = 'none' / offsetHeight / style.animation = ''
      // sequence was a synchronous forced reflow on every single slide change
      // for no actual effect. Removed as part of the performance audit.

      syncVideos();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      if (!autoplay || paused || locked) return;
      stopAuto();
      timer = setInterval(next, autoplaySpeed);
      root.dataset.paused = 'false';
    }

    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function setPaused(p) {
      paused = p;
      root.dataset.paused = p ? 'true' : 'false';
      if (playPauseBtn) {
        playPauseBtn.dataset.state = p ? 'paused' : 'playing';
        playPauseBtn.setAttribute('aria-label', p ? 'Play autoplay' : 'Pause autoplay');
      }
      if (p) stopAuto(); else startAuto();
    }

    // Wire controls
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAuto(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-fbs-dot'), 10);
        goTo(i);
        startAuto();
      });
    });
    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', function () { setPaused(!paused); });
    }

    // Pause on hover (desktop) and when offscreen / tab hidden
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', function () { if (!paused) startAuto(); });

    function onVisibilityChange() {
      if (document.hidden) stopAuto();
      else if (!paused) startAuto();
    }
    // document-level listener — must be explicitly removed in teardown() or
    // it outlives this slider instance every time the theme editor reloads
    // the section (a real leak this fixes, not a hypothetical one: each
    // reload used to add another listener on top of the last).
    document.addEventListener('visibilitychange', onVisibilityChange);

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !paused) startAuto();
          else stopAuto();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    }

    // Keyboard
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); startAuto(); }
      else if (e.key === 'ArrowLeft') { prev(); startAuto(); }
    });

    // Touch swipe
    var touchStartX = 0, touchDeltaX = 0;
    viewport.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
      stopAuto();
    }, { passive: true });
    viewport.addEventListener('touchmove', function (e) {
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });
    viewport.addEventListener('touchend', function () {
      if (Math.abs(touchDeltaX) > 50) {
        if (touchDeltaX < 0) next(); else prev();
      }
      startAuto();
    });

    function lock() {
      locked = true;
      stopAuto();
    }

    function unlock() {
      locked = false;
      startAuto();
    }

    function teardown() {
      stopAuto();
      if (io) io.disconnect();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      delete root.dataset.fbsInit;
      delete root._farfheBanner;
    }

    root._farfheBanner = { start: startAuto, stop: stopAuto, goTo: goTo, lock: lock, unlock: unlock, teardown: teardown };

    syncVideos();
    startAuto();
  }

  function init() {
    document.querySelectorAll('[data-farfhe-banner]').forEach(initSlider);
  }

  // Fix: pause any playing slide videos while the mobile nav drawer is open.
  // (CSS hides the slider visually; this also stops playback/sound.)
  function pauseAllSliderVideos() {
    document.querySelectorAll('[data-farfhe-banner] video').forEach(function (video) {
      try { video.pause(); } catch (e) {}
    });
  }
  function resumeActiveSliderVideos() {
    document.querySelectorAll('[data-farfhe-banner]').forEach(function (root) {
      var active = root.querySelector('[data-fbs-slide].is-active video, [data-fbs-slide]:first-child video');
      if (active) {
        try {
          var p = active.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (e) {}
      }
    });
  }
  function watchDrawerState() {
    var body = document.body;
    var wasOpen = false;
    var observer = new MutationObserver(function () {
      var isOpen = /overflow-hidden-(tablet|desktop|mobile)/.test(body.className);
      if (isOpen && !wasOpen) {
        pauseAllSliderVideos();
      } else if (!isOpen && wasOpen) {
        resumeActiveSliderVideos();
      }
      wasOpen = isOpen;
    });
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', watchDrawerState);
  } else {
    init();
    watchDrawerState();
  }

  // Shopify theme editor support
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-farfhe-banner]');
      if (section) initSlider(section);
    });

    // Without this, removing/reordering a banner-slider section in the
    // editor left its setInterval, IntersectionObserver, and document-level
    // visibilitychange listener running against a detached DOM node
    // indefinitely (one leaked instance per edit, for the rest of the
    // editor session).
    document.addEventListener('shopify:section:unload', function (e) {
      var wrapper = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!wrapper) return;
      var root = wrapper.querySelector('[data-farfhe-banner]');
      if (root && root._farfheBanner) root._farfheBanner.teardown();
    });

    // Jump to and pause on whichever slide's block is selected in the
    // editor sidebar, matching Dawn's own slideshow-section behavior.
    document.addEventListener('shopify:block:select', function (e) {
      if (!e.target.hasAttribute || !e.target.hasAttribute('data-fbs-slide')) return;
      var root = e.target.closest('[data-farfhe-banner]');
      if (!root || !root._farfheBanner) return;
      var index = parseInt(e.target.getAttribute('data-index'), 10);
      root._farfheBanner.lock();
      if (!isNaN(index)) root._farfheBanner.goTo(index);
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (!e.target.hasAttribute || !e.target.hasAttribute('data-fbs-slide')) return;
      var root = e.target.closest('[data-farfhe-banner]');
      if (!root || !root._farfheBanner) return;
      root._farfheBanner.unlock();
    });
  }
})();
